export const composedIdSeparator = `-`;
export const apartmentComposedIdName = 'apartmentComposedId';

export type ComposedIdsConfig = { [name: string]: string };

export const composedIdsConfig: ComposedIdsConfig = {
  [apartmentComposedIdName]: `:companyId${composedIdSeparator}:siteId${composedIdSeparator}:apartmentId`,
};
